import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "mb-10 text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Create an Account", -1)
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-gray-300 mw-100 w-100" })
], -1)
const _hoisted_6 = { class: "row fv-row mb-7" }
const _hoisted_7 = { class: "col-xl-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " University ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select University...", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Gannon University", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Ursuline College", -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "col-xl-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " User type ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select user type...", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "student" }, "Student", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "faculty" }, "Faculty", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "irbmember" }, "IRB Member", -1)
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row fv-row mb-7" }
const _hoisted_23 = { class: "col-xl-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Title ")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select title...", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "Mr." }, "Mr.", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "Dr." }, "Dr.", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "Mrs." }, "Mrs.", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "Ms." }, "Ms.", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "Jr." }, "Jr.", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "Sr." }, "Sr.", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "Other." }, "Other", -1)
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "col-xl-6" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " First Name ")
], -1)
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "row fv-row mb-7" }
const _hoisted_40 = { class: "col-xl-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Middle Name", -1)
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "col-xl-6" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Last Name ")
], -1)
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { class: "row fv-row mb-7" }
const _hoisted_49 = { class: "col-xl-6" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Email ")
], -1)
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { class: "col-xl-6" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Phone ")
], -1)
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = {
  class: "row fv-row mb-7",
  "data-kt-password-meter": "true"
}
const _hoisted_58 = { class: "col-xl-6" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Password ")
], -1)
const _hoisted_60 = { class: "position-relative mb-3" }
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { class: "col-xl-6" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Confirm Password ")
], -1)
const _hoisted_65 = { class: "fv-plugins-message-container" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = { class: "fv-row mb-10" }
const _hoisted_68 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-gray-700 fs-6" }, [
  /*#__PURE__*/_createTextVNode(" I Agree & "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "ms-1 link-primary"
  }, "Terms and conditions"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_70 = { class: "text-center" }
const _hoisted_71 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
      novalidate: "novalidate",
      onSubmit: _ctx.onSubmitRegister,
      id: "kt_login_signup_form",
      "validation-schema": _ctx.registration
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(" Already have an account? "),
            _createVNode(_component_router_link, {
              to: "/sign-in",
              class: "link-primary fw-bolder"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Sign in here ")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_Field, {
              name: "university",
              class: "form-select form-select-solid",
              as: "select"
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10,
                _hoisted_11
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_ErrorMessage, { name: "university" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Field, {
              name: "userrole",
              class: "form-select form-select-solid",
              as: "select"
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                _hoisted_17,
                _hoisted_18,
                _hoisted_19
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_ErrorMessage, { name: "userrole" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(_component_Field, {
              name: "title",
              class: "form-select form-select-solid",
              as: "select"
            }, {
              default: _withCtx(() => [
                _hoisted_25,
                _hoisted_26,
                _hoisted_27,
                _hoisted_28,
                _hoisted_29,
                _hoisted_30,
                _hoisted_31,
                _hoisted_32
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_ErrorMessage, { name: "title" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "firstname",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_ErrorMessage, { name: "firstname" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "middlename",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_ErrorMessage, { name: "middlename" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "lastname",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_ErrorMessage, { name: "lastname" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "email",
              placeholder: "",
              name: "email",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_ErrorMessage, { name: "email" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _hoisted_54,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "phone",
              placeholder: "",
              name: "phonenumber",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_ErrorMessage, { name: "phonenumber" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("div", _hoisted_60, [
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "password",
                placeholder: "",
                name: "password",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createVNode(_component_ErrorMessage, { name: "password" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "password",
              placeholder: "",
              name: "cpassword",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createVNode(_component_ErrorMessage, { name: "cpassword" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("label", _hoisted_68, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "checkbox",
              name: "toc",
              value: "1"
            }),
            _hoisted_69
          ])
        ]),
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("button", _hoisted_71, _hoisted_74, 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}